import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import '../Assets/Styles/partners.css';
// import ReactTransitionGroup from 'react-transition-group/TransitionGroup';

import {TimelineLite} from 'gsap'

class PartnersContainer extends Component {

	constructor() {
    super();
    this.state = {
    	partners: [
        {
          href: 'www.geico.com?utm_source=marvel&utm_medium=referral&utm_campaign=brand-partners-page&utm_content=logo',
          image: require('../Assets/Images/Partners/geico.png')
        },
        {
          href: 'http://skittles.com/',
          image: require('../Assets/Images/Partners/skittles.png')
        },
        {
          href: 'https://www.doritoschooseyourguardian.com/',
          image: require('../Assets/Images/Partners/doritos.png')
        },
        {
          href: 'https://www.dairyqueen.com/',
          image: require('../Assets/Images/Partners/dq.png')
        },
        {
          href: 'http://marvel.com/EcoSport',
          image: require('../Assets/Images/Partners/ford.png')
        },
        {
          href: 'https://www.facebook.com/gogurtusa',
          image: require('../Assets/Images/Partners/gogurt.png')
        },
          {
          href: 'http://www.hanes.com/',
          image: require('../Assets/Images/Partners/hanes.png')
         },
          {
          href: 'https://www.youtube.com/user/mmschocolate',
          image: require('../Assets/Images/Partners/mms.png')
        },
        {
          href: 'http://www.synchronybank.com/',
          image: require('../Assets/Images/Partners/synchrony.png')
        },
        {
          href: 'http://www.screenvisionmedia.com/',
          image: require('../Assets/Images/Partners/screenvision.png')
        },
        {
          href: 'http://www.tourgeorgiafilm.com/',
          text: 'Tour Georgia'
        }
      ]
    }
  }

  componentDidMount(){

  }


  componentWillEnter (callback) {
    console.log('character container component will enter')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 0
    }).to(el, 0.8, {
      opacity: 1
    })
  }

  omponentDidEnter () {
    console.log('character container component entered')
  }

  componentWillLeave (callback) {
    console.log('character container component will leave')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 1,
    }).to(el, 0.8, {
      opacity: 0,
    })
  }

  componentDidLeave () {
    console.log('character container component left')
  }


  renderPartners() {
  	return this.state.partners.map((partner, i) => {
      let image
      if(partner.text){
        image = (<span>{partner.text}</span>)
      } else {
        image = (<img src={partner.image} alt=""/>)
      }
  			return (
  				<li key={i}><a href={partner.href} target="_blank">{image}</a></li>
				)
  	})
  }

  render() {
  	let partners = this.renderPartners()
    return (
      <div className='partners-list'>
      	<div className="character-close-button" onClick={this.props.closePartners}></div>
        <ul>
      		{partners}
        </ul>
      </div>
    );
  }
}

export default PartnersContainer;


// WEBPACK FOOTER //
// ./src/Components/partnersContainer.js